// web_components/wcFeaturesBanner/wcFeaturesBanner_Renderer.ts

/**
 * Generates the HTML for the wc-features-banner component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-features-banner${variables.parallaxEnabled == 'true' ? ' wc-features-banner__parallax' : ''}">
        	${
				variables.videoBackground
					? `
				<video class="wc-features-banner__video-bg" playsinline autoplay muted loop poster="${variables.imageBackground}">
				  <source src="${variables.videoBackground}" type="video/mp4">
				</video>
			`
					: `
                <div class="wc-features-banner__image" style="background-image: url(${variables.imageLarge})"></div>
			`
			}
			<div class="wc-features-banner__container">
				<div class="wc-features-banner__content">
					<h2 class="wc-features-banner__heading">${variables.heading}</h2>
					<span class="wc-features-banner__subheading">${variables.subheading}</span>
		
					<ul class="wc-features-banner__items">
						${
							variables.item1Heading
								? `
							<li class="panel-item">
								<span>${variables.item1Heading}</span>
								<p>${variables.item1Text}</p>
							</li> 
						`
								: ''
						}
						${
							variables.item2Heading
								? `
							<li class="panel-item">
								<span>${variables.item2Heading}</span>
								<p>${variables.item2Text}</p>
							</li> 
						`
								: ''
						}
						${
							variables.item3Heading
								? `
							<li class="panel-item">
								<span>${variables.item3Heading}</span>
								<p>${variables.item3Text}</p>
							</li> 
						`
								: ''
						}
						${
							variables.item4Heading
								? `
							<li class="panel-item">
								<span>${variables.item4Heading}</span>
								<p>${variables.item4Text}</p>
							</li> 
						`
								: ''
						}
						${
							variables.item5Heading
								? `
							<li class="panel-item">
								<span>${variables.item5Heading}</span>
								<p>${variables.item5Text}</p>
							</li> 
						`
								: ''
						}
						${
							variables.item6Heading
								? `
							<li class="panel-item">
								<span>${variables.item6Heading}</span>
								<p>${variables.item6Text}</p>
							</li> 
						`
								: ''
						}
					</ul>
				</div>
			</div>
		</section>
    `;
}
